import React, { Component } from 'react';
class TaxProfileContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b >  Reports:</b></p>
                <p>As a administrator , user can schedule a reports on monthly basis or Adhoc basis. Multiple reports exists in the system.</p>
                <p ><b > 1. Agency Commission Report:</b></p>
                <p>Reports Contains Commission Details of all agencies registered in the application. Commission amount is displayed based on the run parameters. Eg Commission calculated for month Feb 2021.</p>
                <p ><b > 2. Broker Commission Report:</b></p>
                <p>Reports Contains Commission Details of all brokers registered in the application. Commission amount is displayed based on the run parameters. Eg Commission calculated for month Feb 2021.</p>
                <p ><b > 3. Carrier Summary Report</b></p>
                <p>Reports Contains plan and profile details of all carriers registered in the application. .</p>
                <p ><b > 4.Agency Outstanding Payment Report:</b></p>
                <p>Reports Contains Outstanding payment details of all agencies registered in the application. Outstanding amount is displayed based on the run parameters. Eg Outstanding payment  for month Feb 2021.</p>
                <p ><b > 5. Broker Outstanding Payment Report:</b></p>
                <p>Reports Contains Outstanding payment details of all brokers registered in the application. Outstanding amount is displayed based on the run parameters. Eg Outstanding payment  for month Feb 2021.</p>
                <p ><b > 6. Reconcialtion Report:</b></p>
                <p>Reports Contains reconcilation details of all agencies and brokers registered in the application.</p>
            </div>
        )
    }
}
export default TaxProfileContent;
